import axios from 'axios';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async getLmsCourses(_obj, params) {
    const res = await axios.get(`api/lms/lms-courses/`, { params });
    return res.data;
  },
  async getCourse(_obj, id) {
    const res = await axios.get(`api/lms/lms-courses/${id}/`);
    return res.data;
  },
  async createCourse(_obj, data) {
    const res = await axios.post(`api/lms/lms-courses/`, data);
    return res.data;
  },
  async updateCourse(_obj, { id, data }) {
    const res = await axios.patch(`api/lms/lms-courses/${id}/`, data);
    return res.data;
  },
  async deleteCourse(_obj, id) {
    const res = await axios.delete(`api/lms/lms-courses/${id}/`);
    return res.data;
  },
  async getCourseImageUploadPresignedUrl(_obj, data) {
    const res = await axios.post(`api/lms/lms-courses/upload-url/`, data);
    return res.data;
  },
  async getProgramCourses(_obj, params) {
    const res = await axios.get(`api/lms/lms-courses/program-courses/`, { params });
    return res.data;
  },
  async getProgramAssignedCourses(_obj, params) {
    const res = await axios.get(`api/lms/lms-courses/program-assigned-courses/`, { params });
    return res.data;
  },
  async canUpdateCourseCategory(_obj, params) {
    const res = await axios.get(`api/lms/lms-courses/can-update-course-category/`, { params });
    return res.data;
  },
  async getStdAssignedCourse(_obj, params) {
    const res = await axios.get(`api/lms/lms-courses/std-assigned-courses/`, { params });
    return res.data;
  },
};

export const courses = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
